const mockDomains = {
  items: [
    {
      name: 'Providers',
      dimensions: [
        {
          id: '98d4fd8b-25df-4713-b244-969d3de2dcf1',
          name: 'vijayTestOrg-3006524'
        }
      ]
    },
    {
      name: 'Categories',
      dimensions: [
        {
          id: 'business office',
          name: 'Business Office'
        },
        {
          id: 'cdk drive',
          name: 'CDK Drive'
        },
        {
          id: 'communications',
          name: 'Communications'
        },
        {
          id: 'crm',
          name: 'CRM'
        },
        {
          id: 'digital sales',
          name: 'Digital Sales'
        },
        {
          id: 'embedded insurance',
          name: 'Embedded Insurance'
        },
        {
          id: 'f&i',
          name: 'F&I'
        },
        {
          id: 'fixed ops',
          name: 'Fixed Ops'
        },
        {
          id: 'intelligence',
          name: 'Intelligence'
        },
        {
          id: 'it solutions',
          name: 'IT Solutions'
        },
        {
          id: 'parts',
          name: 'Parts'
        }
      ]
    }
  ]
};

const apiTypeSet = [
  {
    id: 'restApi',
    name: 'REST'
  },
  {
    id: 'asyncApi',
    name: 'Async'
  },
  {
    id: 'bundles',
    name: 'Bundles'
  }
];
const mockApiData = [
  {
    id: '300sdfsdfdsf',
    kind: 'api',
    orgId: 'c95f3dsfsdcb1',
    name: 'API FOR TEST',
    orgName: 'CDK Global',
    orgLogo: 'data:image/jpeg;base64,some imageB//Z',
    description: '# Details.\n',
    tags: ['bar', 'foo'],
    plans: [
      {
        parentPlanId: '',
        type: 'Advanced',
        plan: 'basic',
        name: 'Basic',
        description: 'dsjkjsdflkjf',
        price: 9.99,
        freeDays: 0,
        visibility: 'public',
        status: 'active',
        containers: [
          {
            name: 'All Endpoints',
            description: 'All Eniner',
            quota: 100000,
            overage: 0.0025,
            isFree: false,
            id: 'e6dc8c62-bb89-4420-8167-1fd3306f5377',
            endPoints: [
              {
                summary: 'Get a list of AAIA years',
                apiInstanceId: '0083161c-0b75-4333-9a78-e29fd3705fc3',
                route: '/get-aaia-years',
                verb: 'get'
              }
            ]
          }
        ],
        groupId: 'f608ac5dsfdsf9e',
        groupName: 'ksdjfklsjf',
        startDate: '2024-03-12T20:03:22.604Z',
        id: '107sdfsd05200'
      }
    ],
    terms: [],
    visibility: 'public',
    verticalScoping: true,
    apiType: 'api',
    sharedWithOrg: false,
    summary: 'sdfghjkl'
  },
  {
    id: '1yy7',
    kind: 'api',
    orgId: '4ed',
    name: 'QM-1',
    orgName: 'cdkSurya',
    orgLogo: '',
    description: 'To n',
    tags: ['test'],
    plans: [
      {
        id: 'fpp',
        type: 'advanced',
        plan: 'basic',
        name: 'Bplan',
        description: 'desc3',
        price: '425',
        freeDays: 60,
        visibility: 'public',
        status: 'active',
        containers: [
          {
            name: 'Get Endpoints',
            description: 'Dents',
            quota: 10000,
            overage: '0.02',
            endPoints: [
              {
                route: '/get-req-1',
                verb: 'GET'
              },
              {
                route: 'post-req-1',
                verb: 'POST'
              }
            ]
          }
        ],
        startDate: '2022-08-17T09:41:11.952Z'
      },
      {
        id: 'f50a9',
        type: 'advanced',
        plan: 'Essentials',
        name: 'Eplan',
        description: 'desc4',
        price: '1000',
        freeDays: 60,
        visibility: 'public',
        status: 'active',
        containers: [
          {
            name: 'Post Endpoints',
            description: 'eded',
            quota: 13300,
            overage: '1.02',
            endPoints: [
              {
                route: '/get-qw-1',
                verb: 'POST'
              }
            ]
          }
        ],
        startDate: '2022-08-17T09:41:11.952Z'
      },
      {
        name: 'newtrans',
        type: 'Tiered',
        visibility: 'public',
        rates: [
          {
            endUnit: 1234,
            startUnit: 0,
            rate: 0.3
          }
        ],
        id: '1761',
        status: 'active',
        startDate: '2022-08-17T09:41:11.952Z'
      }
    ],
    terms: [],
    visibility: 'public',
    verticalScoping: false,
    apiType: 'api',
    sharedWithOrg: false,
    summary: null
  }
];

const mockAsyncApiData = [
  {
    id: '3002721',
    kind: 'async-api',
    orgId: 'c9b1',
    name: 'TEST ASYNC',
    orgName: 'CDK Global',
    orgLogo: 'data:image/jpeg;base64,/9j/4gggggNB//Z',
    description: '# dersdtnc.\n',
    tags: ['sd', 'fosdso'],
    plans: [
      {
        parentPlanId: '',
        type: 'Advanced',
        plan: 'pro',
        name: 'Pro',
        description: 'dsjkjsdflkjf',
        price: 3.99,
        freeDays: 12,
        visibility: 'public',
        status: 'active',
        containers: [
          {
            name: 'xczxyz',
            description: 'sd',
            quota: 10220,
            overage: 0.0025,
            isFree: false,
            id: 'e6d306f5377',
            endPoints: [
              {
                summary: 'Gzxczypes',
                apiInstanceId: '00831z5fc3',
                route: '/get-type',
                verb: 'post'
              }
            ]
          }
        ],
        groupId: 'f6089f9e',
        groupName: 'hfgh',
        startDate: '2024-03-17T20:03:22.604Z',
        id: '107-ae81-4fd5f2c05200'
      }
    ],
    terms: [],
    visibility: 'public',
    verticalScoping: true,
    apiType: 'api',
    sharedWithOrg: false,
    summary: 'sdfghjkl'
  }
];

const mockBundleData = [
  {
    id: 'ffc9c2d0-2f52-4c54-9f76-6c7fdcac8930',
    name: 'test_as_public_bundle_1',
    description: 'something',
    weight: 0,
    status: 'active',
    apis: [
      {
        id: 'd35156c1-9ddc-49fb-a988-beee1003b91b',
        name: 'AmitTestApi073',
        type: 'api'
      },
      {
        id: '69add06e-3da9-4c97-a336-7535cc8148d2',
        name: 'AmitTestAsyncApi014',
        type: 'async-api'
      }
    ],
    visibility: 'public',
    isContracted: false,
    sharedWithOrg: true
  }
];

export {
  mockDomains,
  mockApiData,
  mockAsyncApiData,
  mockBundleData,
  apiTypeSet
};
